export default __webpack_public_path__ + "static/media/mariah.2489e368.png";